<main class="layout--stepper">
  <section class="tabs-container">
    <tabs
      data-test-id="documentCenterTabLabels"
      tabLabels]="tabLabels"
      (tabSelected)="onDocTabSelected($event)"
    >
      @for (documentFolder of tabLabels; track documentFolder; let i = $index) {
        <zip-table
          [attr.data-test-id]="'documentCenterTable-' + i"
          *templateRef
          (cellClicked)="cellClicked($event)"
          [options]="tableConfig"
        >
        </zip-table>
      }
    </tabs>
  </section>
</main>
